import { getSearchParam, sessionStorage } from '@shared/utils';

import constants from '@/utils/constants';
import { textConstant } from '@/constants';
import {
	LOGIN_REDIRECTION_FAILURE_CODE,
	LOGIN_REDIRECTION_STATE,
} from '@/containers/loginRedirection/LoginRedirection.types';

const {
	LOGIN_REDIRECTION: {
		VERIFICATION_SUCCESS,
		VERIFICATION_SUCCESS_DESC,
		ONBOARDING_URL_MISMATCH,
		ONBOARDING_URL_MISMATCH_DESC,
		INVALID_MERCHANT_TYPE,
		INVALID_MERCHANT_TYPE_DESC,
		ONBOARDING_INCOMPLETE,
		ONBOARDING_INCOMPLETE_DESC,
		GENERIC_ERROR,
		TECHNICAL_ISSUE,
	},
} = textConstant;

export interface IRedirectionUIContext {
	headerText: string;
	description: string;
	logoUrl: string;
	bannerUrl: string;
}
export interface IRedirectionContext {
	flowType: string;
	redirectUrl: string;
	uiContext: IRedirectionUIContext;
}

export interface ILoginTextContent {
	header: string;
	description: string;
	bannerUrl: string;
}

export interface IRedirectionStoredContext {
	flowType: string;
	redirectUrl: string;
	logoUrl: string;
}

const { LOGIN_REDIRECTION_KEY } = constants;

export const isLoginRedirectFlow = () =>
	Boolean(sessionStorage.getItem(LOGIN_REDIRECTION_KEY));

export const getParsedContext = (data: string): IRedirectionContext | null => {
	if (!data) return null;
	return JSON.parse(atob(data));
};

export const getLoginRedirectionContext = () =>
	getParsedContext(getSearchParam(location.search, 'redirectionContext') || '');

export const setLoginRedirectionContext = (): IRedirectionContext | null => {
	try {
		const redirectionData = getLoginRedirectionContext();
		if (!redirectionData) return null;

		sessionStorage.setItem(
			LOGIN_REDIRECTION_KEY,
			JSON.stringify({
				flowType: redirectionData.flowType,
				redirectUrl: redirectionData.redirectUrl,
				logoUrl: redirectionData.uiContext.logoUrl,
				bannerUrl: redirectionData.uiContext.bannerUrl,
			}),
		);
		return redirectionData;
	} catch (error) {
		return null;
	}
};

export const getLoginRedirectionStoredContext =
	(): IRedirectionStoredContext => {
		const loginRedirectionData = sessionStorage.getItem(LOGIN_REDIRECTION_KEY);
		return loginRedirectionData
			? JSON.parse(loginRedirectionData)
			: { flowType: '', logoUrl: '', redirectUrl: '' };
	};

export const getVerificationContext = (
	verificationState: LOGIN_REDIRECTION_STATE,
	verificationErrorCode: string,
) => {
	if (verificationState === LOGIN_REDIRECTION_STATE.VERIFIED) {
		return {
			header: VERIFICATION_SUCCESS,
			description: VERIFICATION_SUCCESS_DESC,
		};
	}
	switch (verificationErrorCode) {
		case LOGIN_REDIRECTION_FAILURE_CODE.ONBOARDING_URL_MISMATCH:
			return {
				header: ONBOARDING_URL_MISMATCH,
				description: ONBOARDING_URL_MISMATCH_DESC,
			};
		case LOGIN_REDIRECTION_FAILURE_CODE.INVALID_MERCHANT_TYPE:
			return {
				header: INVALID_MERCHANT_TYPE,
				description: INVALID_MERCHANT_TYPE_DESC,
			};
		case LOGIN_REDIRECTION_FAILURE_CODE.INVALID_MERCHANT_STATE:
		case LOGIN_REDIRECTION_FAILURE_CODE.ONBOARDING_MISSING_DETAILS:
			return {
				header: ONBOARDING_INCOMPLETE,
				description: ONBOARDING_INCOMPLETE_DESC,
			};
		default:
			return {
				header: TECHNICAL_ISSUE,
				description: GENERIC_ERROR,
			};
	}
};
